import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/vip/icon-close.png'
import _imports_1 from '../../assets/images/buyVip/success-icon.png'
import _imports_2 from '../../assets/images/buyVip/serve-wechat.png'
import _imports_3 from '../../assets/images/buyVip/paper.png'


const _hoisted_1 = { class: "vip-success" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "success-content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "buy-success-tips-top" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", null, "购买成功")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "content-bottom"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_8 = {
  key: 0,
  style: {"width":"60px"}
}
const _hoisted_9 = {
  key: 1,
  class: "code-box"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "common-text scan-code-icon" }, "扫描二维码", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "code-img-box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    class: "code-img"
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "get-gift" }, "添加客服领取赠品", -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  style: {"width":"128px"}
}
const _hoisted_15 = { class: "browser-right" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "common-text brower-icon" }, "上次浏览", -1)
const _hoisted_17 = { class: "browser-right-info" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "paper-img"
}, null, -1)
const _hoisted_19 = { class: "paper-info" }
const _hoisted_20 = { class: "paper-title" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "去使用", -1)
const _hoisted_22 = [
  _hoisted_21
]

import { ref, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from 'vuex'
import { clickPcpaperPopuppaysuccessBlank} from '@/trace/xesTrackVip.ts';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyVipSuccess',
  props: {
    successDialogInfo: {
        type: Object,
        default: () => ({
            msgs: [],
            hasGifts: false,
        }),
    },
    entrance: {
        type: String,
        default: '',
    },
    position: {
        type: String,
        default: '',
    },
},
  emits: ['closeSuccesInfo'],
  setup(__props, { emit }) {

const props = __props;

/**
 * @description:会员购买成功弹窗
 *
 */
const router = useRouter();
const store = useStore();


const preBrowseInfo = computed(() => store.state.paperPreBrowse.preBrowse || null);



const handleClose = () => {
    store.dispatch('closeVipDialog');
    emit('closeSuccesInfo');
}

  
  //查看上次浏览的试卷
const toCheck = () => {
    console.log('去看看')
    clickPcpaperPopuppaysuccessBlank({
        content: '去查看',
        position: props.position,
        entrance: props.entrance,
    });

    store.dispatch('closeVipDialog');
    // const url = router.resolve({
    //   path: 'single-paper',
    //   query: {
    //     'paper_id':  preBrowseInfo.value?.id,
    //   }
    // });
    // window.open(url.href, '_blank');
    window.location.reload();
};

//去使用会员
const toUseVip = () => {
    clickPcpaperPopuppaysuccessBlank({
        content: '去使用',
        position: props.position,
        entrance: props.entrance,
    });
    // 去使用 跳转试卷包首页
    store.dispatch('closeVipDialog');
    emit('closeSuccesInfo');
    router.replace('/paper');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "close-btn",
      onClick: handleClose
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(['buy-success-tips',{'no-bottom':!(__props.successDialogInfo?.hasGifts || preBrowseInfo.value)}])
      }, [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.successDialogInfo?.msgs, (val) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vip-name",
            key: val
          }, _toDisplayString(val), 1))
        }), 128)),
        (!(__props.successDialogInfo?.hasGifts || preBrowseInfo.value))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "goto-use",
              onClick: toUseVip
            }, "去使用"))
          : _createCommentVNode("", true)
      ], 2),
      (__props.successDialogInfo?.hasGifts || preBrowseInfo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", {
              class: _normalizeClass(`content-bottom-info ${!preBrowseInfo.value ? 'center-info' : ''}`)
            }, [
              (preBrowseInfo.value && __props.successDialogInfo?.hasGifts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                : _createCommentVNode("", true),
              (__props.successDialogInfo?.hasGifts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_13))
                : _createCommentVNode("", true),
              (preBrowseInfo.value && __props.successDialogInfo?.hasGifts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                : _createCommentVNode("", true),
              (preBrowseInfo.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: _normalizeClass(`browser-history-box ${preBrowseInfo.value && __props.successDialogInfo?.hasGifts ? 'mt-20' : ''}`)
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(preBrowseInfo.value?.name), 1),
                          _createElementVNode("div", {
                            class: "check-paper-btn",
                            onClick: toCheck
                          }, "查看")
                        ])
                      ])
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (__props.successDialogInfo?.hasGifts && !preBrowseInfo.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "check-paper-btn",
            onClick: toUseVip
          }, _hoisted_22))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})